<template>
  <perfect-scrollbar id="users" class="content">
    <div class="lthHeaderCnt">
      <div class="lBtn selectAll" v-if="1>2">
        <div class="theSelect"><div class="selectIn"></div></div>
      </div>
      <div class="lBtn refresh" v-on:click="getUsers"></div>
      <a class="lBtn download" :href="$config.uri('misc/resep-sehat/download')"
        target="_blank">
        Download CSV
      </a>
      <div class="searchCnt">
        <form v-on:submit.prevent="search">
          <input type="text" class="field" placeholder="Search user..."
            v-on:input="search" v-model="query">
          <button></button>
        </form>
      </div>
      <div class="pagination">
        <div class="pageInfo">{{((page * limit) + 1).toLocaleString('id')}}-{{((page
          * limit) + results.length).toLocaleString('id')}} dari
          {{total.toLocaleString('id')}}</div>
        <div :class="{pageBtn: 1, pagePrev: 1, disabled: page === 0}"
          v-on:click="prevPage"></div>
        <div :class="{pageBtn: 1, pageNext: 1, disabled: ((page
          * limit) + results.length) >= total}"
          v-on:click="nextPage"></div>
        <div class="pageBtn config">
          <div class="ddCnt">
            <div class="ddItem">
              <h4>Item Per Page</h4>
              <div class="radioCnt">
                <div class="radioItem" v-on:click="setItemPerPage(25)">
                  <div :class="{radio: 1, checked: limit === 25}"></div>
                  25 item per page
                </div>
                <div class="radioItem" v-on:click="setItemPerPage(50)">
                  <div :class="{radio: 1, checked: limit === 50}"></div>
                  50 item per page
                </div>
                <div class="radioItem" v-on:click="setItemPerPage(100)">
                  <div :class="{radio: 1, checked: limit === 100}"></div>
                  100 item per page
                </div>
                <div class="radioItem" v-on:click="setItemPerPage(150)">
                  <div :class="{radio: 1, checked: limit === 150}"></div>
                  150 item per page
                </div>
                <div class="radioItem" v-on:click="setItemPerPage(250)">
                  <div :class="{radio: 1, checked: limit === 250}"></div>
                  250 item per page
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="listingCnt">
      <div class="listingItemCnt">
        <table>
          <tr>
            <th class="th1">Name</th>
            <th>Date</th>
            <th colspan="2">Status</th>
          </tr>
          <tbody v-if="loading">
            <tr>
              <td colspan="5" class="tdLoading">
                <SkAnimation :thumb="false" :tab="false" :header="false" type="user"/>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(item, index) in results" :key="item.id">
              <td class="td1">
                <div class="profile hasPhoto" v-if="item.avatar"
                  :style="{'background-image': `url('${item.avatar}')`}"></div>
                <div class="profile" v-else-if="item.name">{{item.name.substr(0,2)}}</div>
                {{item.name}}
                <p v-if="item.email">{{item.email.toLowerCase()}}</p>
                <p v-else-if="item.phone">{{item.phone}}</p>
              </td>
              <td>{{item.birthdate}}</td>
              <td>
                <span v-if="item.member_amway === 1">Yes</span>
                <span v-else>No</span>
              </td>
              <td>
                <span v-if="item.recipes_submited > 0">
                  {{item.recipes_submited}} recipes
                </span>
                <span v-else>None</span>
              </td>
              <td>
                <div class="action" v-on:click="itemOpenedId = item.id"></div>
                <div :class="{actionOverlay: true, open: itemOpenedId == item.id}"
                  v-on:click="itemOpenedId = null"></div>
                <div :class="{actionCnt: true, open: itemOpenedId == item.id}">
                  <div class="actionItem actionRed" v-on:click="deleteUser(index, item)">
                    <img src="../assets/delete.png"> Delete
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <AddUser ref="userDialog"/>
    <FormInputerShort ref="formInputer"/>
  </perfect-scrollbar>
</template>

<script>
import { mapActions } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import AddUser from '@/components/AddUser.vue';
import SkAnimation from '@/components/SkAnimation.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';

export default {
  name: 'home',
  components: {
    Confirmation,
    Snackbar,
    AddUser,
    SkAnimation,
    FormInputerShort,
  },
  data() {
    return {
      limit: 25,
      page: 0,
      total: 0,
      loading: true,
      results: [],
      itemOpenedId: null,
      role: '',
      roles: [],
      searchTimer: null,
      query: '',
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    search(e) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getUsers();
      }, 500);
    },
    deleteUser(i, item) {
      this.itemOpenedId = null;
      const name = (item.name) ? item.name : 'User';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: `Are you sure you want to delete ${name}?
          This operation can not be undone.`,
      }, (b) => {
        if (b) this.deleteNow(i, item);
      });
    },
    deleteNow(i, item) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: `To prevent from accidentally deleted user,
          you need to input your password.`,
        placeholder: 'Password',
        type: 'password',
        action: 'Delete User',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$http.post(this.$config.uri('misc/resep-sehat/delete'), {
          id: item.id,
        }).then((response) => {
          if (response.data.status !== 200) {
            // Display error
            return;
          }
          const name = (item.name) ? item.name : 'User';
          this.$refs.snackbar.open({ content: `${name} has been deleted.` });
        });
      });
    },
    undoDelete() {
      this.$http.post(this.$config.uri('user/restore'), { id: this.userWillDelete.id })
        .then((response) => {
          if (response.data.status !== 200) {
            // Display error
            return;
          }

          this.getUsers();
          this.snackbarAction = null;
          this.showSnackbar = `<b>${this.userWillDelete.name}</b> has been restored.`;
          setTimeout(() => {
            this.showSnackbar = null;
          }, 5000);
        });
    },
    nextPage() {
      if (((this.page * this.limit) + this.results.length) >= this.total) return;
      this.page += 1;
      this.getUsers();
    },
    prevPage() {
      if (this.page === 0) return;
      this.page -= 1;
      this.getUsers();
    },
    setItemPerPage(itemPerPage) {
      this.limit = itemPerPage;
      this.getUsers();
    },
    getUsers() {
      this.loading = true;
      const uri = `misc/resep-sehat?limit=${this.limit}&page=${this.page}&q=${this.query}`;
      this.$http.get(this.$config.uri(uri)).then((response) => {
        this.loading = false;
        this.results = (response.data.status === 200)
          ? response.data.data : [];
        this.total = (response.data.status === 200) ? response.data.total : 0;
      });
    },
  },
  mounted() {
    this.role = this.$route.params.role;
    this.chTitle('Kompetisi Resep Sehat');
    this.chCGB(false);
    this.getUsers();
  },
};
</script>


<style scoped lang="scss">
  .lthHeaderCnt .lBtn{
    &.download{
      width: auto;
      display: flex;
      align-items: center;
      padding: 0 20px;
      border-radius: 50px;
      margin-right: 0;
      padding-left: 46px;
      position: relative;
      color: #222;
      opacity: .7;
      border: #ddd 1px solid;
      &:before{
        content: "";
        position: absolute;
        left: 16px; top: 0; bottom: 2px;
        width: 18px;
        background-image: url(../assets/download-o.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }

  .listingItemCnt{
    margin: 0 -30px;
  }
  .listingHeader{
    padding: 5px 20px;
    padding-left: 18px;
    .exportAll{
      float: right;
      background-color: #0057d8;
      font-size: 15px;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      transition: all .2s linear;
      color: #fff;
      cursor: pointer;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
    }
    .exportAll:hover{
      background-color: #0067ff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    }
    .lhItem{
      font-size: 15px;
      float: left;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      opacity: .5;
      transition: all .2s linear;
      cursor: pointer;

      position: relative;
      padding-left: 62px;
      float: none;
      margin-right: 0;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
      .checkAll{
        width: 14px; height: 14px;
        border: #777 2px solid;
        border-radius: 4px;
        float: left;
        margin-right: 10px;
      }
    }
    .lhItem.rejectAll{
      opacity: 1;
      color: red;
    }
    .lhItem:before{
      content: "";
      position: absolute;
      left: 12px; top: -1px;
      width: 36px; height: 36px;
      background-color: #ccc;
      border-radius: 50%;
    }
    .lhItem:hover{
      // background-color: #eee;
      opacity: 1;
    }
  }
  table{
    border-collapse: collapse;
    width: 100%;
    tr{
      th{
        text-align: left;
        font-weight: bold;
        color: #999;
        padding: 10px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        text-transform: uppercase;
      }
      th.th1{
        padding-left: 80px;
      }
      td{
        padding: 14px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        position: relative;
        white-space: nowrap;
        &.tdLoading{
          padding: 0 30px;
          // border: none;
          &:hover{
            background-color: #fff;
          }
        }
        &.td1{
          padding-left: 80px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 200px;
          font-weight: 600;
          p{
            margin: 2px 0 0;
            font-weight: normal;
            color: #767676;
          }
        }
        .profile{
          left: 30px;
          top: 50%;
          margin-top: -18px;
          position: absolute;
          width: 36px;
          height: 36px;
          // background-image: url(../assets/user.png);
          background-color: #0e5dd2;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 50%;
          opacity: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          text-transform: uppercase;
          line-height: 1;
        }
        .action{
          position: absolute;
          right: 14px;
          top: 6px;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background-image: url(../assets/more.png);
          background-size: 18px auto;
          background-repeat: no-repeat;
          background-position: center;
          opacity: .4;
          cursor: pointer;
        }
        .action:hover{
          background-color: #ddd;
          opacity: .7;
        }
        .actionCnt{
          position: absolute;
          background: #fff;
          top: 40px;
          // border: 1px solid #ccc;
          box-shadow: 1px 1px 4px rgba(0,0,0,.2);
          border-radius: 10px;
          padding: 10px 0;
          white-space: nowrap;
          text-align: left;
          right: 14px;
          z-index: 4;
          margin-top: -5px;
          display: none;
          .divider{
            border-top: #eee 1px solid;
            padding-top: 4px;
            margin-top: 4px;
          }
          .actionItem{
            cursor: pointer;
            list-style: none;
            padding: 7px 42px;
            color: #444;
            font-size: 14px;
            min-width: 100px;
            img{
              height: 15px;
              margin: -4px 4px -2px -22px;
            }
          }
          .actionItem.actionRed{
            color: red;
          }
          .actionItem:hover{
            background-color: #eee;
          }
        }
        .actionCnt.open{
          display: block;
        }
        .actionOverlay{
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
          display: none;
        }
        .actionOverlay.open{
          display: block;
        }
      }
      td.tdHeader{
        padding: 0;
      }
    }
    tbody{
      tr:hover{
        background-color: #f5f5f5;
        background-color: #f0f4ff;
        // cursor: pointer;
      }
    }
  }
</style>
